import {Component} from '@angular/core';

@Component({
  selector: 'app-circle-store-icon',
  templateUrl: './circle-store-icon.component.html'
})
export class CircleStoreIconComponent {
}
